export const UserRoleEnum = {
  VET: 'ROLE_VET',
  VET_TECH: 'ROLE_VET_TECH'
};
